import http from "../../../utils/services/http-client";
import {BorrowRequestApprovalByOwner} from "../models";
import urlHelper from "../../../utils/urlHelper/UrlHelper";

class CartableService {
  getReceivedBorrowRequest(model:any) {
    const queryParams = urlHelper(model);
    return http.get(`/BorrowRequest?${queryParams}`);
  }
  getSentBorrowRequest() {
    return http.get(`/BorrowRequest/GetSentBorrowRequests`);
  }
  registerBorrowRequestApprovalByOwner(model:BorrowRequestApprovalByOwner) {
    return http.put(`/BorrowRequest/BorrowRequestApprovalByOwner` ,model);
  }
  registerBorrowRequestApprovalByBorrower(model:BorrowRequestApprovalByOwner) {
    return http.put(`/BorrowRequest/BorrowRequestApprovalByBorrower` ,model);
  }

}

export default new CartableService();
